import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { useVispOptions } from '@/shared/api/reference'

interface VispSelectProps {
  value?: string | null
  onChange?: (value: string | undefined) => void
  /** Faqat faol VISP va faol Center — biriktirish uchun */
  assignableOnly?: boolean
  /** Kvotali VISPlar ro'yxatda bo'lmaydi — ularga abonent ko'chirilmaydi */
  excludePooled?: boolean
  /** Faqat kvotali VISPlar — VISP tanlash huquqisiz ham hovuzdan ro'yxatdan o'tkazish mumkin */
  pooledOnly?: boolean
  placeholder?: string
  allowClear?: boolean
}

export function VispSelect({
  value,
  onChange,
  assignableOnly = false,
  excludePooled = false,
  pooledOnly = false,
  placeholder,
  allowClear,
}: VispSelectProps) {
  const { t } = useTranslation()
  const visps = useVispOptions()
  const options = visps
    .filter((v) => (!assignableOnly || v.assignable) && (!excludePooled || !v.pooled) && (!pooledOnly || v.pooled))
    .map((v) => ({
      value: v.id,
      label: `${v.centerName} / ${v.name}${v.isDefault ? ` (${t('network.default')})` : ''}${
        v.pooled ? ` · ${t('network.visps.freeCount', { count: v.available })}` : ''
      }`,
    }))
  return (
    <Select
      value={value ?? undefined}
      onChange={onChange}
      options={options}
      showSearch
      optionFilterProp="label"
      placeholder={placeholder}
      allowClear={allowClear}
      style={{ width: '100%' }}
    />
  )
}
